import { PureComponent } from 'preact-compat'

import Button from '@insided/control/uikit/Button'
import { ContentType } from '@insided/shared/utils/contentType'
import { getFormattedPollData } from '../utils'
import { Poll as PollType } from '../interfaces'
import PollEditor from './PollEditor'

export interface PollProps {
  poll: PollType
  onShowAlert: (type: 'success' | 'error', message?: string) => void
  contentType: ContentType
  topicId: number
  onPollUpdate: (data: Pick<PollType, 'question'> | Pick<PollType, 'options'>) => void
}

export interface PollState {
  showPollEditor: boolean
}

class Poll extends PureComponent<PollProps, PollState> {
  constructor(props: PollProps) {
    super(props)
    this.onTogglePollEditor = this.onTogglePollEditor.bind(this)

    this.state = {
      showPollEditor: false
    }
  }

  onTogglePollEditor = (show: boolean) => {
    this.setState({ showPollEditor: show })
  }

  render() {
    const { onPollUpdate, poll, onShowAlert, contentType, topicId } = this.props
    const { showPollEditor } = this.state
    const pollData = poll.options && poll.voteCount && getFormattedPollData(poll.options, poll.voteCount)
    const displayTitles = poll.question !== ''

    return showPollEditor ? (
      <PollEditor
        onShowAlert={onShowAlert}
        poll={poll}
        onPollUpdate={onPollUpdate}
        contentType={contentType}
        topicId={topicId}
        onTogglePollEditor={this.onTogglePollEditor}
      />
    ) : (
      <div className='poll--content'>
        <p className='poll--title'>{displayTitles && `Poll question: ${poll.question}`}</p>
        <div>
          <p className='poll--title'>{displayTitles && 'Poll options:'}</p>
          {pollData?.map(({ option, vote, percentage }) => {
            return (
              <div className='poll--vote-results' key={option}>
                <div className='poll--vote-progress'>
                  <div className='poll--vote-progress-bar' style={{ width: `${percentage}%` }} />
                </div>
                <div className='poll--vote-option' key={option}>
                  {' '}
                  {`${option} - ${vote} vote(s) (${percentage}%)`}
                </div>
              </div>
            )
          })}
        </div>
        <Button
          title='Edit poll'
          variant='secondary'
          onClick={() => this.onTogglePollEditor(true)}
          data-qa='edit-poll'
        />
      </div>
    )
  }
}

export default Poll
